export default __webpack_public_path__ + "images/e1259df3864a1e2e61e8b281e9fa6b3d.png";